import { Button } from "../ui/button";

export function LoadMoreMessagesButton({
  onClick,
  isLoading,
}: {
  onClick: () => void;
  isLoading: boolean;
}) {
  return (
    <div className="flex items-center justify-center gap-2 mt-2">
      <Button
        variant="outline"
        size="sm"
        className="px-2 h-7 text-xs"
        onClick={onClick}
        loading={isLoading}
        loadingText="Loading older messages..."
      >
        Load older messages
      </Button>
    </div>
  );
}
